module.exports = __webpack_public_path__ + "media/images/pages/solutions/automation/hero-7d5af646a450ba4594212301618830e1.svg";